<template>
  <a :href="link" target="_blank" class="social-nav-item-link">
    <span v-html="iconSVG"></span>
  </a>
</template>

<script>
import simpleIcons from 'simple-icons'

export default {
  name: 'SocialNav',
  props: ['icon', 'link'],
  computed: {
    iconSVG() {
      return simpleIcons[this.icon].svg
    }
  }
}
</script>

<style lang="scss">
.social-nav-item-link {
  svg {
    fill: rgba(255, 255, 255, 0.5);
  }
}
</style>
